import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'output',
})
export class FormatOutputPipe implements PipeTransform {
  constructor() {}

  transform(input: any | string): any {
    return input === null || input === '' ? '-' : input;
  }
}
